<template>
    <div class="costAgreement">
        <webHeader></webHeader>
        <div class="xylog">
            <p class="bgtitle">共享经济合作伙伴协议</p>
            <div class="one">《共享经济合作伙伴协议》（以下简称“本协议”）为云账户（天津）共享经济信息咨询有限公司（以下简称“云账户”）与您（即本协议项下的个体经营者）签订的合作协议。如果您不同意本协议的任意内容，请不要勾选或以其他方式确认本协议。您点击勾选或以其他方式确认本协议，即表示您已充分阅读、理解并同意接受本协议的全部内容。<span>本协议中有部分斜体、加下划线的条款，该等条款可能影响您的权益或涉及您的个人信息，请您重点阅读。</span></div>
            <div class="one"><span>特别声明：</span></div>
            <div class="one"><span>本协议项下的个体经营者（即您）仅限于从事生产经营活动的个人或本协议项下的个体工商户，与您名下注册的其他个体工商户没有任何关系，如您与企业客户存在劳动关系、劳务关系或其他类似劳动人事法律关系或您担任企业客户（含关联方）的法定代表人、股东、董事、监事等，则您不能承揽云账户为满足该企业客户的业务需求而发布的任务。</span></div>
            <div class="one"><span>您同意并确认，经云账户认定后，如您所从事的生产经营活动按照云账户内部政策需注册个体工商户的，您应通过津智云商商事登记管理系统完成个体工商户登记注册事项，否则，云账户有权拒绝就该类生产经营活动与您开展合作且不承担违约责任。</span></div>
            <div class="one"><span>一经发现违反上述规定行为的，云账户有权取消您使用云账户服务的资格及申请注销本协议项下的个体工商户，并有权上报相关国家机关，由相关国家机关根据《中华人民共和国税收征收管理法》及其他相关法律法规的规定追究责任主体的法律责任。</span></div>
            <div class="titles">鉴于：</div>
            <div class="one">云账户享有使用共享经济资源平台及服务系统（以下称为“云账户综合服务平台”）的合法授权，可为您提供共享经济综合服务，主要包括基于您的资质或劳动技能为您匹配适合的生产经营活动以及核算生产经营收入等。您与云账户依据《中华人民共和国合同法》及相关法律法规的规定，本着平等、自愿、诚信的原则，在平等互利的基础上友好协商并签署本协议。</div>
            <div class="item">
                <p class="titles">第一条  定义</p>
                <p class="items">除非本协议中另有定义，下列词语应具有以下特定涵义：</p>
                <p class="items">1、关联方：指相互间直接或间接持有其中一方的股权总和达到25%或以上的；或者直接或间接同为第三者所拥有或控制股权达到25%或以上的。如果一方通过中间方对另一方间接持有股份，只要其对中间方持股比例达到25%以上，则其对另一方的持股比例按照中间方对另一方的持股比例计算；两个以上具有夫妻、直系血亲、兄弟姐妹以及其他抚养、赡养关系的自然人共同持股同一企业，在判定关联关系时持股比例合并计算。</p>
                <p class="items">2、津智云商商事登记管理系统：指云账户（含关联方）开发的用于登记注册个体工商户的系统。</p>
                <p class="items">3、个体工商户：指从事生产经营活动的个人通过津智云商商事登记管理系统登记并经云账户主管市场监督管理局核准，注册成立的个体工商户（为免疑义，本协议项下的个体工商户不包括通过其他途径登记注册的个体工商户）。</p>
                <p class="items">4、个体经营者：指自我雇佣、自我管理、自担成本、自负盈亏并通过云账户综合服务平台从事合法合规生产经营活动的个人或本协议项下的个体工商户。</p>
                <p class="items">5、生产经营收入（税后）：指个体经营者从事生产经营活动而取得的税后收入。</p>
                <p class="items">6、服务费：指由云账户向企业客户提供共享经济综合服务，云账户就该服务向企业客户收取的费用。</p>
            </div>
            <div class="item">
                <p class="titles">第二条 合作内容</p>
                <p class="items">1、云账户为满足企业客户的业务需求而通过云账户综合服务平台向适合的个体经营者发布任务，您可根据自身资质或劳动技能选择是否接受前述活动。</p>
                <p class="items">2、云账户通过云账户综合服务平台公布活动内容、活动规则等，您可据此查询、接受活动内容，并承诺在从事生产经营活动过程中遵守前述活动规则、承担相关义务；云账户根据您任务完成的数量和质效核算、支付您的生产经营收入（税后）。</p>
                <p class="items">3、您应当按照有关税收法律法规、政策规定及税务机关的要求，履行个人所得税纳税义务。鉴于云账户具备合法的个人所得税代征资质，云账户将按照有关税收法律法规、政策规定及云账户主管税务机关的要求协助您完成个人所得税税款的缴纳。</p>
            </div>
            <div class="item">
                <p class="titles">第三条 生产经营收入（税后）的结算及支付方式</p>
                <p class="items">1、根据云账户与企业客户签署的《共享经济综合服务协议》的约定，云账户基于企业客户业务需求所对应的活动内容及费用标准向企业客户提供共享经济综合服务并收取服务费。云账户收到企业客户支付的服务费后，将根据您任务完成的数量和质效核算、支付您的生产经营收入（税后）。</p>
                <p class="items">2、您应自行负担就您取得的生产经营收入需缴纳的各项税款，应云账户要求，您应提供与个人所得税申报缴纳相关的协助及信息；云账户承诺依法协助您完成个人所得税税款缴纳并确保您取得税后合法收入。</p>
            </div>
            <div class="item">
                <p class="titles">第四条 您的权利与义务</p>
                <p class="items">1、您保证签署本协议时具有完全民事权利能力和民事行为能力或系已满十六周岁未满十八周岁经法定监护人同意的民事主体，并满足所有履行本协议所需的法定条件或约定条件，保证在从事生产经营活动时，遵照相关活动规则并自备所需要的设备设施、自行承担必要费用，如因您个人原因造成您本人或任意第三方损害的，由您承担全部法律责任。</p>
                <p class="items">2、您保证具有从事云账户发布的生产经营活动所需的资质或劳动技能。如果您所从事的生产经营活动需经相关国家机关许可或以其他方式进行的，您应先行取得相关许可并按照法律规定的方式从事生产经营活动，否则您应自行承担全部法律后果，并赔偿由此给云账户造成的全部损失。</p>
                <p class="items">3、您有权在云账户处查询生产经营收入（税后）的核算方式、取得生产经营收入（税后）。您保证所从事的生产经营活动是以您个人名义或您登记注册的个体工商户的名义进行的，与您名下非通过津智云商商事登记管理系统登记注册的个体工商户（为免疑义，特指非本协议项下的个体工商户）没有任何关系；您保证不以云账户的名义从事任何与本协议项下的生产经营活动无关的业务。</p>
                <p class="items">4、如您通过津智云商商事登记管理系统登记注册了个体工商户，您同意并授权由云账户保管该个体工商户的所有证件、公章、印鉴等资料。您不应将注册完成后获取的电子证照用作本协议项下合作事项以外的其他事项，您同时保证不应使用您通过津智云商商事登记管理系统登记注册的个体工商户的名义开展非本协议约定的其他活动，包括但不限于与云账户以外的任何机构进行合作或向其提供服务（与云账户建立合作关系的机构除外）。</p>
                <p class="items">5、您保证在生产经营活动过程中遵守国家法律法规，不得从事违反法律或行政法规等行为（包括但不限于涉嫌传销、赌博、暴力、淫秽、恐怖行为、洗钱、偷税、漏税、逃税）及其他不得使用云账户服务的行为，云账户主管税务机关或其他相关国家机关介入调查时，您应当予以协助并如实反映情况，不得阻挠、拒绝调查。</p>
                <p class="items">6、您充分理解个体经营者的定义，并承诺不存在下列所述情形：</p>
                <p class="items">6.1承揽的生产经营活动系为了满足与您存在劳动关系、劳务关系或其他类似的劳动人事法律关系的企业客户的业务需求；</p>
                <p class="items">6.2承揽的生产经营活动系为了满足由您担任法定代表人、股东、董事、监事等的企业客户（含关联方）的业务需求；</p>
                <p class="items">6.3其他不适用于云账户服务范围的人员。</p>
                <p class="items">7、您同意并授权云账户为实现本协议合作目的收集、留存并合法使用您的个人信息，<span>云账户收集、使用您个人信息的类型和目的包括：</span></p>
                <p class="items"><span>（1）共享经济综合服务。为了您可以使用云账户共享经济综合服务，向您付款及协助您完成个税缴纳，执行服务验证、升级服务，改善云账户现有服务、帮助云账户设计新服务，云账户将收集并使用您的姓名、手机号码、身份证号码或其他有效证件号码、身份证照片、银行账号或其他收款账户信息、个税缴纳信息、活动内容及生产经营收入。</span></p>
                <p class="items"><span>（2）客户服务。为方便联系您，同时能够及时响应您的需求，为您提供更好的服务，云账户将收集您的电子邮箱、联系地址、联系电话。</span></p>
                <p class="items"><span>云账户将按照法律规定、采取符合业界标准的安全防护措施保护您的个人信息。</span></p>
                <p class="items"><span>8、您理解并确认，云账户收集、使用您的下列个人信息无需征得您的授权同意：与国家安全、国防安全、犯罪侦查、起诉、审判和执行判决、商业秘密等直接相关的信息、您自行向社会公众公开的信息、云账户从合法公开披露的信息中收集的您的个人信息及其他法律法规或相关国家标准规定无需征得您授权同意的信息。</span></p>
                <p class="items">9、您保证向云账户提供的信息均是真实的、有效的、合法的，如信息发生变更应及时通知云账户，否则因此造成的一切不利后果由您承担。您的收款账户信息以您实名提交至云账户综合服务平台后台的信息为准，且您保证该收款账户为纳税义务人（即您本人）所有。自云账户将应支付的生产经营收入（税后）支付至您的收款账户之日起，视为您收到前述费用。如因您提供信息有误等导致付款失败的，您应独自承担相应责任。您承诺使用前述收款账户的行为符合中华人民共和国法律的规定，如果云账户收到云账户主管税务机关或其他相关国家机关任何调查请求的，您应提供协助并如实反映情况。</p>
                <p class="items">10、如经过云账户认定，您所从事的生产经营活动需要注册个体工商户的，您应当配合提供云账户为协助您登记注册个体工商户所需要收集的您的相关个人信息（包括您的姓名、身份证及其他有效证件的号码及照片、动态面部识别特征、签字样本）。</p>
                <p class="items"><span>11、为更好地向您提供服务，您授权并同意云账户在下列情形下共享您的个人信息：</span></p>
                <p class="items"><span>（1）与关联公司共享：为准确无误地向您支付生产经营收入（税后），您同意并授权云账户将您的姓名、身份证号、收款账户信息及联系方式共享给云账户的合作机构进行信息核验，云账户将采用加密措施保证您的前述个人信息不被泄露。</span></p>
                <p class="items"><span>（2）与企业客户共享：为给您筛选适当的生产经营活动及了解您的生产经营情况，您授权并同意将您的个人信息共享给企业客户。</span></p>
                <p class="items"><span>12、云账户只会共享必要的个人信息，且受本协议合作目的的约束。关联公司或企业客户如要改变您个人信息的处理目的，云账户将再次征求您的授权同意。对云账户与之共享个人信息的公司、组织和个人，云账户会与其签署严格的保密协定或约定保密条款，要求他们按照云账户的说明、本协议以及其他任何相关的保密约定，采取安全措施来处理个人信息。</span></p>
                <p class="items"><span>13、按照中国相关的法律、法规、标准等相关文件，您有权更正、删除您的个人信息或改变您授权同意的范围，收回授权同意可能影响您使用某些产品或服务，云账户会在您收回授权同意时向您说明。您可以通过本协议第九条中罗列的方式向云账户提出申请，云账户会在收到申请后30个自然日内回复您的请求。但您收回授权同意的决定，不会影响此前基于您的授权而开展的个人信息处理。</span></p>
                <p class="items">14、您应当勤勉履行本协议，维护云账户形象，不得损害云账户的合法权益。</p>
            </div>
            <div class="item">
                <p class="titles">第五条 云账户的权利与义务</p>
                <p class="items">1、基于企业客户的业务需求及您的资质或劳动技能，云账户有权就您从事的生产经营活动制定相应的活动标准，云账户将敦促您遵守前述活动标准并不得违背相关法律法规，但该等敦促为平等主体之间为实现合同目的的敦促，适用《中华人民共和国合同法》约束，且不导致云账户与您之间构成劳动关系、劳务关系、任何担保或被担保关系，亦不导致云账户对您提供服务所引起的纠纷承担任何连带责任。</p>
                <p class="items">2、在企业客户及时、足额向云账户支付服务费的情况下，您发起的生产经营收入（税后）的提现或支付申请，由云账户根据您任务完成的数量和质效核算、支付您的生产经营收入（税后），您从事的生产经营活动超出云账户发布任务的除外。</p>
                <p class="items">3、云账户在向您支付生产经营收入（税后）时，有权在云账户所在地向云账户主管税务机关代您进行临时税务登记或个体工商户税务登记，并按照有关税收政策规定及云账户主管税务机关的要求，协助您完成个人所得税税款缴纳。</p>
                <p class="items">4、如您通过津智云商商事登记管理系统注册了个体工商户，该个体工商户的所有证件、公章、印鉴等资料，均由云账户代您保管，云账户承诺将妥善保管，并不得出于本协议之外的其他目的而使用。</p>
                <p class="items">5、云账户发现您违反本协议第四条第6款之约定的，有权立即中止或终止履行本协议，有权代您申请注销本协议项下的个体工商户（如适用），且您不得拒绝，并有权向云账户主管税务机关报告，您应自行承担由此产生的税务相关的处罚责任（包括但不限于根据云账户主管税务机关的要求补缴相应的税款、滞纳金、罚金）。</p>
                <p class="items">6、云账户有权留存并合法使用为实现本协议合作目的从您处获取的您的个人信息，云账户（含股东会、董事会、监事会成员及高级管理人员）承诺对您所披露的个人信息进行保密，除经您授权或基于合法并可执行的法律、法规、法院命令、监管机构的要求或为遵守适用法律法规、履行网络安全保护义务或应对网络安全事件的需要外，云账户（含股东会、董事会、监事会成员及高级管理人员）不得将您的个人信息披露给本协议约定之外的任意第三方。云账户承诺按照相关法律法规的要求对您的个人信息履行安全保护义务，保障网络免受未经授权的访问，防止网络数据泄露或被窃取、篡改。</p>
                <p class="items"><span>7、云账户有权按照本协议第四条的相关约定收集、使用、共享您的个人信息。当云账户要将您的个人信息用于本协议未载明的其他用途或将基于特定目的收集而来的信息用于其他目的时，会事先征求您的同意。</span></p>
                <p class="items">8、云账户因网络服务的特殊性，可能需短时间中断服务对津智云商商事登记管理系统或云账户综合服务平台进行维护和升级，您理解并认可前述行为不属于云账户违约情形。</p>
                <p class="items">9、云账户可为您提供养老保险的缴纳等服务，具体服务细则由双方另行约定。</p>
                <p class="items">10、云账户应当勤勉履行本协议，不得损害您的合法权益。</p>
            </div>
            <div class="item">
                <p class="titles">第六条 违约责任</p>
                <p class="items">1、除本协议另有约定外，本协议任意一方不履行或不完全履行本协议约定的义务和承诺即构成违约。违约方应当负责赔偿其违约行为给守约方造成的一切经济损失（包括但不限于合理的律师费、诉讼费、公证费）。</p>
                <p class="items">2、如您违反相关法律法规或社会公序良俗给云账户造成损失的（包括但不限于经济损失、商誉或企业形象损失），云账户有权向您主张损害赔偿。</p>
                <p class="items">3、因政府行为（包括但不限于因政府机关不授予或调整云账户相应经营资质或权利）或其他不可抗力因素导致本协议部分条款或全部条款无法履行的，遭受该行为的一方不承担违约责任。</p>
            </div>
            <div class="item">
                <p>第七条 保密责任</p>
                <p class="items">1、本协议任意一方应对本协议所涉及的所有内容以及协议双方在执行本协议过程中相关的法律、商业、合作业务的所有信息进行保密。未经对方允许，均不得向本协议约定之外的任意第三方披露（但前述保密信息已经公开、在签署本协议之前已通过其他合法来源获悉或应司法机关、行政机关要求进行披露的除外）。</p>
                <p class="items">2、保密期限应为：自协议生效之日起至协议终止后十年。</p>
            </div>
            <div class="item">
                <p class="titles">第八条 适用法律、争议及纠纷解决和司法管辖</p>
                <p class="items">本协议的订立、执行、解释及争议的解决均应适用中华人民共和国境内法律。凡因本协议引起的或与本协议有关的任何争议，协议双方应友好协商解决。如不能协商解决，双方一致同意提交至被告所在地有管辖权的人民法院诉讼解决。</p>
            </div>
            <div class="item">
                <p class="titles">第九条 通知</p>
                <p class="items">1、有效联系方式</p>
                <p class="items">云账户按照法律规定或本协议约定收集到的您的联系方式均为有效联系方式，如您的联系方式发生变更，您有义务及时更新有关信息，并保持可被联系的状态。</p>
                <p class="items">云账户将通过您的联系方式的其中之一或其中若干向您送达各类通知，而此类通知的内容可能对您的权利义务产生重大的有利或不利影响，请您务必及时关注。</p>
                <p class="items">2、通知的送达</p>
                <p class="items">云账户通过上述联系方式向您发出通知，其中以电子方式发出的书面通知，包括但不限于向您的联系电话发送手机短信、向您的电子邮箱发送电子邮件，通知在发送成功后即视为送达。</p>
                <p class="items">您可以通过您预留的电子邮箱、服务热线等方式向云账户发出通知，您通过前述联系方式发出的通知视为您本人的意思表示，在发送成功后即视为送达；您以纸质载体发出的书面通知，按照云账户联系地址交邮后的第五个自然日即视为送达。</p>
            </div>
            <div class="item">
                <p class="titles">第十条 协议的变更与终止</p>
                <p class="items">1、云账户有权根据需要不定期更新本协议条款，并在企业客户APP或以其他方式予以公布。如您同意所修改的内容，请点击勾选或以其他方式确认继续使用云账户服务；如您不同意所修改的内容，请立即停止使用云账户服务。</p>
                <p class="items">2、如发生以下任一情形，您有权以本协议第九条所列的方式通知云账户终止本协议：</p>
                <p class="items">2.1云账户破产或被取消营业资格的；</p>
                <p class="items">2.2本协议更新后，您不同意所修改内容并停止使用云账户服务的；</p>
                <p class="items">2.3您不愿继续使用云账户服务的。</p>
                <p class="items">3、您应遵守本协议约定、相关法律法规的规定及社会公序良俗，云账户有权自主判断您的行为是否违约或违规。发生下列情形时，云账户有权在不事先通知的情况下，限制或停止您使用云账户服务的资格，情形严重的，云账户有权以本协议第九条所列的方式通知您终止本协议并有权代您注销本协议项下的个体工商户（如适用）且您不得拒绝：</p>
                <p class="items">3.1如云账户有合理理由或有证据认定您违反本协议约定、相关法律法规或社会公序良俗的（包括但不限于涉嫌传销、赌博、暴力、淫秽、恐怖行为、洗钱、偷税、漏税、逃税）；</p>
                <p class="items">3.2如云账户有合理理由或有证据认定您存在危害国家统一、颠覆国家政权、损害国家荣誉或利益、破坏民族团结的行为或发表前述相关言论的；</p>
                <p class="items">3.3您违反云账户的活动规则等，且在云账户警告后3个工作日内仍未改正的；</p>
                <p class="items">3.4云账户按照法律规定或有权机关的要求终止向您提供服务的；</p>
                <p class="items">3.5其他原因导致本协议无法继续履行的。</p>
            </div>
        </div>
        <app-footer class="footer-desc"></app-footer>
    </div>
</template>
<script>
import footer from '@/components/footer'
import webHeader from "@/components/webHeader";
//当前实例组件
export default {

    data: () => ({
        url:'',
        name:''
    }),
    components: {"app-footer":footer,webHeader},
    created() {
      var that = this;
      const data = this.$tools.getLocal("userinfo");
      that.name = data.name
    },
    methods: {
        gonn:function(){
            var rou = this.$router.resolve('/new_notice');
            window.open(rou.href, '_blank');
        },
        goIndex:function(){//跳转到首页
            var userinfo=this.$tools.getLocal("userinfo");
            var level=userinfo.level;
            if(level==2){//二级机构   回二级机构首页
                this.$router.push('/index_content2');

            }else{//一级机构   回一级机构首页
                this.$router.push('/index_content');
            }
        },
        gonn:function(){
            var rou = this.$router.resolve('/new_notice');
            window.open(rou.href, '_blank');
        },
        out: function(e) {
            if (e != 10) {
                this.handleSelect(e);
            } else {
                this.loginOut()
                localStorage.removeItem('userinfo')
                localStorage.removeItem('all')
                localStorage.removeItem('queryMechanInfo')
                // this.$tools.setLocal("userinfo", "");
                this.$router.push("/");
            }
        },
        handleSelect(e) {
            //侧边栏选择回调
            var that = this;
            if(that.$tools.getLocal("userinfo")){
                let e1=e.split("?")[0];
                let url1=this.url.split("?")[0];
                if (e1== url1) {
                e=e.replace('/#','');
                // that.$router.replace(e);
                that.$router.push(e);
                that.reload=false;
                setInterval(function(){
                    that.reload=true;
                },100)
                } else {
                that.url=e;
                e=e.replace('/#','');
                that.$router.push(e);
                //  that.reload=false;
                //  setInterval(function(){
                //   that.reload=true;
                // },100)
                }
            }else{
                this.$router.push('/login')
                this.$notice.msg('请重新登录',2,1500);
            }
        },
    },
    mounted() {

    }
};
</script>
<style lang="scss" scoped>
.costAgreement{
  .footer-desc {
      position: relative;
      width: 100%;
      padding: 20px 0;
      margin: auto;
      font-size: 14px;
      text-align: center;
      color: #ccc;
      p{
          line-height: 30px;
      }
      a{
          color: #ccc;
      }
  }
  .xylog{
      padding: 90px 40px 10px 40px;
      color: #333;
      span {
          font-style:oblique;
          text-decoration:underline;
      }
      .bgtitle{
          text-align: center;
          margin-bottom: 20px;
          font-size: 22px;
          font-weight: 700;
          color: #000;
      }
      .one{
          text-indent: 20px;
          font-size: 14px;
          line-height: 24px;
          margin-top: 5px;
      }
      .item{
          margin-top: 10px;
          .items{
              line-height: 24px;
          }
      }
      .titles{
          font-size: 16px;
          margin-bottom: 5px;
          color: #000;
          font-weight: 600;
      }
  }
  .header {
      position: absolute;
      top: 0;
      left: 0;
      padding: 0 60px;
      width: 100%;
      height: 80px;
      border-bottom: 1px solid #eee;
      background: #fff;
      box-sizing: border-box;
      .logo {
          float: left;
          cursor: pointer;
          img {
              float: left;
              display: block;
              margin-top: 20px;
          }
          .word {
              float: left;
              padding-top: 20px;
              margin-left: 10px;
              span {
                  display: block
              }
              .title {
                  font-size: 28px;
                  font-weight: 700;
                  letter-spacing: 2px;
              }
              .desc {
                  font-size: 14px;
                  letter-spacing: 2px;
                  margin-top: 6px;
              }
          }
      }
      .left {
          float: right;
          .mailbox {
              float: left;
              position: relative;
              padding-top: 30px;
              margin-right: 35px;
              cursor: pointer;
          }
          .headerimg {
              float: left;
              img {
                  width: 36px;
              }
              .bs {}
              .geren {
                  width: 130px;
              }
              .xl {
                  padding-top: 23px;
                  font-size: 14px;
                  img {
                      // float: left;
                      margin-right: 10px;
                  }
                  .xl {
                      width: 150px;
                  }
                  .el-dropdown {
                      cursor: pointer;
                  }
              }
          }
      }
  }
}
</style>
